module.exports = __webpack_public_path__ + "static/callout-66016576a8c82a7ab7eb4b1386feb24e.jpg";